import {
  useListTaskListsByHabitat,
  useUpdateTaskListItem,
} from '@akin-home/checklists/frontend';
import { useHabitatID } from '@akin-home/habitats/react';
import { useMemo } from 'react';
import {
  AddRecipeIngredientParams,
  addRecipeIngredientToShoppingListItems,
  removeRecipeIngredientFromShoppingListItems,
} from '../models';

/** Gets just the shoping list */
const useShoppingList = () => {
  const habitatID = useHabitatID();

  const { lists, ...result } = useListTaskListsByHabitat({ habitatID });

  const setChecklistItem = useUpdateTaskListItem();

  const shoppingList = useMemo(
    () => lists.find((l) => l.primaryShoppingList),
    [lists]
  );

  const addItem = (params: AddRecipeIngredientParams) => {
    if (shoppingList) {
      setChecklistItem({
        id: shoppingList.id,
        checklist: addRecipeIngredientToShoppingListItems(
          shoppingList.checklist
        )(params),
      });
    }
  };

  const addItems = (items: AddRecipeIngredientParams[]) => {
    if (shoppingList) {
      setChecklistItem({
        id: shoppingList.id,
        checklist: items.reduce((checklist, current) => {
          return addRecipeIngredientToShoppingListItems(checklist)(current);
        }, shoppingList.checklist),
      });
    }
  };

  const removeItem = (itemID: string, recipe_id: string) => {
    if (shoppingList) {
      setChecklistItem({
        id: shoppingList.id,
        checklist: removeRecipeIngredientFromShoppingListItems(
          shoppingList.checklist,
          itemID,
          recipe_id
        ),
      });
    }
  };

  const removeItems = (item_ids: string[], recipe_id: string) => {
    if (shoppingList) {
      setChecklistItem({
        id: shoppingList.id,
        checklist: item_ids.reduce((checklist, current) => {
          return removeRecipeIngredientFromShoppingListItems(
            checklist,
            current,
            recipe_id
          );
        }, shoppingList.checklist),
      });
    }
  };

  return {
    shoppingList,
    addItem,
    addItems,
    removeItem,
    removeItems,
    ...result,
  };
};

export default useShoppingList;
